import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import {Link} from "react-router-dom";
import ModalD from "react-awesome-modal";
import * as moment from "moment";
import { isApiResponse } from '../../helpers/utils.js';
import jwt_decode from "jwt-decode";
class SingleCsvReportDownload extends Component{
    constructor(props) {
        super(props);
        this.state ={
            model_visible : false,
            file_url: '',
            rfile: '',
            fetch_data:false,
            download_type:"",
            download_queue_msg:''
        }

    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id,
        });
    }
    downLoadReport (filters, endpoint, name, range){

        var that = this;
        var a = moment(filters.end_date);
        var b = moment(filters.start_date);
        var days_beet = a.diff(b, 'days');
        if(range === undefined || range === 'undefined' || range === '' || range === null)
        {
            if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
                alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
                return false;
          }
        } else {
            if(days_beet>range) {
                alert("Date range too large. Please select a date range of "+ range+ " days at a time");
                return false;
            }
        }

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false,
            download_type:"",
            download_queue_msg:'',
            download_state:""
        });

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/report-csv-download",
            type: "POST",
            data: {
                filters: filters,
                endpoint: endpoint
            },
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },

            success: function (response, status, xhr) {

                this.setState({
                    fetch_data:true,
                    download_type: response.download_type
                })

                if(response.download_type==='Standard') {
                    this.copyEodFile(response.data, name);
                }
                if(response.download_type==='Queue_Download_Offline') {
                    this.setState({
                        download_queue_msg:response.download_msg.status

                    })
                }
                if(response.download_type==='Queue_Download_Online') {
                this.check_download_status(response.download_msg.download_id, response.download_msg.status, response.download_msg.user_id, name);
                this.setState({
                    download_queue_msg:response.download_msg.status,

                })
              }

            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyEodFile (remotePath,name){
       var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = new Date().getTime()+name+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    check_download_status(download_id, status, user_id, name){
        var interval = 5000;
        var start = 1;
        var that = this;
        var timing =function(){
            var timer = setInterval(function(){
                console.log(interval);
                if(that.state.download_state==='Complete') {
                    //alert("hi");
                    clearInterval(timer);
                    return false;

                }
                start++;
                if(start<5){ console.log("in 5");
                    interval = 5000;
                    clearInterval(timer);
                    timing();
                } else if(start>=5 && start<9) { console.log("in 10");
                    interval = 10000;
                    clearInterval(timer);
                    timing();
                } else if(start>=9 && start<=14) { console.log("in 20");
                    interval = 20000;
                    clearInterval(timer);
                    timing();
                }   else { console.log("in timeout");
                    that.setState({
                        download_type:'Queue_Download_Offline'
                    })
                    clearInterval(timer);
                    return false;
                }
                that.check_status(download_id, status, user_id, name, timer);
            },interval);
        }
        timing();
    }
    check_status(download_id, status, user_id, name, timer){

            axios.post(config.get('API_URL')+'/reports/check_download_status/', {
                user_id: this.state.user_id,
                download_id: download_id
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            console.log("res", response);
            if(response.data.data.status==='Complete'){
                let file_path_list = JSON.parse(response.data.data.downloaded_file_path)
                console.log(file_path_list);
                file_path_list.map((path, index) => {
                     this.copyEodFile(path,name,index);
                });
                this.setState({
                    download_type:'Standard',
                    total_count:file_path_list.length,
                    show_count: true,
                    download_state: 'Complete'
                })
                //setTimeout(() => { clearInterval(timer) }, 0);
            }
        })


//         setTimeout(() => { clearInterval(timerId);
//             this.setState({
//                 download_type:'Queue_Download_Offline'
//             })
//         }, 180000);

    }
    render() {
        return(
        <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
            <div className="download-popup-model">
                <div className="message-content">
                    {this.state.file_url==''?
                        <div>
                            {this.state.fetch_data===false?
                                <React.Fragment>
                                    <p>Fetching Data & Generating CSV...</p>
                                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                    </a>
                                </React.Fragment>
                            :null}
                            {this.state.download_type==='Standard'?
                            <React.Fragment>
                                {this.state.fetch_data===false?
                                <p>Fetching Data & Generating CSV…</p>:<p>Fetching File. Please wait…</p>}
                                <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                    <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                </a>
                            </React.Fragment>:null}

                            {this.state.download_type==='Queue_Download_Offline'?
                                <React.Fragment>
                                    <div>
                                        <p>{this.state.download_queue_msg} <Link className="clickheretext" to="/admin/report-download-queue/" >here</Link></p>

                                    </div>
                                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                    </a>
                                </React.Fragment>
                            :null }
                            {this.state.download_type==='Queue_Download_Online'?
                                <React.Fragment>
                                    <div>
                                        {this.state.download_state===""?
                                        <p>Fetching Data & Generating CSV…</p>:<p>Fetching File. Please wait…</p>}
                                    </div>
                                    <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                        <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                    </a>
                                </React.Fragment>
                            :null }
                        </div>

                        :
                        <div className="dwnloadLink">
                            <a href="#" onClick={this.downloadFile.bind(this)}>
                                <i className="fa fa-download" aria-hidden="true"></i>Download
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                            </a>
                        </div>
                    }
                </div>
            </div>
        </ModalD>

        );
    }
}

export default SingleCsvReportDownload